import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';

const SelectAgency = ({
  classes,
  handleChange,
  value,
  agencies,
  errorText,
  disabled,
}) => (
  <React.Fragment>
    <Select
      data-cy="leadAgency"
      id="leadAgency"
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      name="leadAgency"
      onChange={handleChange}
      value={value}
      readOnly={disabled}
      className={classes.reviewDD}
    >
      {agencies.adminUsers.edges.map(item => (
        <MenuItem
          key={item.node.id}
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          value={item.node.id}
        >
          {item.node.fullname}
        </MenuItem>
      ))}
    </Select>
    {errorText && (
      <FormHelperText id="agency-text" style={{ color: '#AF223A' }}>
        {errorText}
      </FormHelperText>
    )}
  </React.Fragment>
);

SelectAgency.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
  agencies: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
};

SelectAgency.defaultProps = {
  disabled: false,
};

export default withStyles(validationFormsStyle)(SelectAgency);
